import { render, staticRenderFns } from "./add-custom-table.vue?vue&type=template&id=fa867232&scoped=true&"
import script from "./add-custom-table.vue?vue&type=script&lang=ts&"
export * from "./add-custom-table.vue?vue&type=script&lang=ts&"
import style0 from "./add-custom-table.vue?vue&type=style&index=0&id=fa867232&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa867232",
  null
  
)

export default component.exports